import BugsnagClient from "@bugsnag/js";

// == Types ================================================================

// == Constants ============================================================

const BUGSNAG_API_KEY =
  process.env.NODE_ENV === "test" ? "xxxx" : process.env.BUGSNAG_API_KEY || "xxxx";

// == Exports ==============================================================

export const Bugsnag = BugsnagClient({
  apiKey: BUGSNAG_API_KEY,
  appType: "client",
  appVersion: "1.0.0",
  releaseStage: process.env.NODE_ENV,
  logger: process.env.NODE_ENV === "test" ? null : console,
  notifyReleaseStages: ["staging", "production"],
});
